var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRodRoomEditIcon = function SvgRodRoomEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.865,
    height: 68.865
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rod-room-edit-icon_svg__a",
    width: 68.865,
    height: 68.865,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rod-room-edit-icon_svg__b",
    width: 48.519,
    height: 48.519,
    x: 9.974,
    y: 10.172,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rod Room"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#rod-room-edit-icon_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    "data-name": "Ellipse 276",
    style: {
      opacity: 0.5,
      fill: "#467181"
    },
    transform: "rotate(-1 398.34 -511.983)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#rod-room-edit-icon_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 251",
    style: {
      stroke: "#fff",
      fill: "#467181"
    },
    transform: "rotate(-1 1023.186 -1136.242)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14.5,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.662 7h-4v4h4zm-4 9h9v-4h-9zm10 0h4v-4h-4zm-5-9v4h9V7z",
    "data-name": "Secondary Layer",
    style: {
      fill: "#fff",
      opacity: 0.5
    },
    transform: "translate(25.771 22.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8-9a1 1 0 0 0 1 1H7a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H-7a1 1 0 0 0-1 1z",
    "data-name": "Primary Layer",
    style: {
      fill: "#fff"
    },
    transform: "translate(34.433 36.315)"
  })));
};
export { SvgRodRoomEditIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";